import classes from './PlotSubobjective.module.css'


function PlotSubobjective(props) {

    let plots = []
    let subscore_names = []
    if(props.objectives.length > 0 ){
        subscore_names = props.objectives.map ( (subscore) => {
            if(subscore.is_score === true) { 
                return subscore.name
            }
            else {
                return undefined
            }
        });
    }


    if(props.svgUrls.length > 0 ){
        let images = props.svgUrls.map ( (url, id) => {
            if(url !== '') { 
                return(<div key={`plot_subobjective_${id}`} style={{marginRight:'10px', width:'400px', height:'fit-content', marginBottom:'10px', padding:'0px', border:'0.5px solid var(--aixelo-gray-light)'}}>
                           <img src={url} alt="SVG loaded from Blob URL" width='400px' height='fit-content' />
                       </div>);
            }
            else {
                return undefined
            }
        }).filter(element => element !== undefined);

        let num_plots = images.length; 
        let per_row = props.plots_per_row;
        let num_rows = Math.floor(num_plots/per_row) // does not include last row
        let plots_last_row = num_plots % per_row // number of plots in the last rwo

        plots = [];
        let plt_count = 0;
        for (let i=0; i<num_rows; i++){
            let plot_row = [];
            for (let j=0; j< per_row; j++){
                plot_row.push(<td key={`"grid_plot_"${j.toString()}`} className={classes.td_plots}>{images[plt_count]}</td>);
                plt_count += 1;
            }
            plots.push(<><tr key={`"grid_plot_final"`}>{plot_row}</tr></>);
        }
        // plot last row (may not be fully filled)
        let plot_row = [];
        for (let j=0; j<plots_last_row; j++){
             plot_row.push(<td key={`"grid_plot2_"${j.toString()}`} className={classes.td_plots}>{images[plt_count]}</td>);
             plt_count += 1;
        }
        plots.push(<><tr key="grid_plot_final2">{plot_row}</tr></>);
    }


    // function downloadPNGs() {
    //     props.svgUrls.forEach((url, index) => {
    //         if (url !== '') {
    //             // Create an image element
    //             const image = new Image();
    //             image.src = url;
    //             image.onload = () => {
    //                 // Create a canvas element
    //                 const canvas = document.createElement('canvas');
    //                 canvas.width = image.width;
    //                 canvas.height = image.height;
    
    //                 // Draw the image on the canvas
    //                 const context = canvas.getContext('2d');
    //                 context.drawImage(image, 0, 0, image.width, image.height);
    
    //                 // Convert the canvas to a PNG blob
    //                 canvas.toBlob((blob) => {
    //                     // Create a download link
    //                     const link = document.createElement('a');
    //                     link.href = URL.createObjectURL(blob);
    //                     // link.download = `image_${index + 1}.png`;
    //                     link.download = `subscore_${subscore_names[index]}.png`;
    
    //                     // Trigger the download
    //                     link.click();
    
    //                     // Clean up
    //                     URL.revokeObjectURL(link.href);
    //                 }, 'image/png');
    //             };
    //         }
    //     });
    // }



    return(<>
        <h4 style = {{marginLeft:'10px', marginTop:'10px', marginBottom:'10px', padding:'0px',}}>Plots Sub-Scores</h4>
        {props.enable_export && (<button className={'actionButtonTiny'} 
                style={{marginLeft:'10px', marginBottom:'15px', width:'100px', height:'25px'}}
                onClick={props.onDownloadPNGs}>Export PNGs</button>)}
        <div style={{marginLeft:'10px', marginBottom:'15px', display:'flex', alignItems:'center'}}>
            <div style={{width:'40px', height:'15px', background:'var(--aixelo-green-light)'}}></div>  
            <span style={{fontSize:'14px', marginLeft:'5px', marginRight:'10px'}}>Target</span>
            <div style={{width:'40px', height:'15px', background:'var(--aixelo-gray-neutral)'}}></div>  
            <span style={{fontSize:'14px', marginLeft:'5px', marginRight:'10px'}}>Okay</span>
            <div style={{width:'40px', height:'15px', background:'var(--aixelo-red-light)'}}></div>  
            <span style={{fontSize:'14px', marginLeft:'5px', marginRight:'30px'}}>No-Good</span>
            <div style={{width:'40px', height:'15px', background:'var(--aixelo-gray-neutral-medium)'}}></div>  
            <span style={{fontSize:'14px', marginLeft:'5px', marginRight:'10px'}}>Auto-Assigned Okay</span>
            <div style={{width:'40px', height:'15px', background:'var(--aixelo-red-medium)'}}></div>  
            <span style={{fontSize:'14px', marginLeft:'5px', marginRight:'10px'}}>Auto-Assigned No-Good</span>
        </div>
        <table className={classes.table_plots} style={{marginLeft:'10px', marginTop:'20px', marginBottom:'10px', width: 'auto', tableLayout: 'auto' }}>
            <thead>
                   {plots}
            </thead>
        </table>
    </> );
}



export default PlotSubobjective;
